<template>
  <div class="r-add-new-customer">
    <Modal
      :draggable="false"
      footer-hide
      :mask-closable="false"
      :styles="{ top: 0, width: '100%', minWidth: '1440px' }"
      v-model="show"
    >
      <div class="title-box">
        <div class="title">{{ $t("addCustomer.title") }}</div>
        <div @click="close" class="common-hover iconfont iconguanbi"></div>
      </div>

      <div class="common-flex common-justify-center new-menu">
        <div
          class="common-hover"
          @click="changeTab(item)"
          v-for="(item, index) in menu"
          :style="[
            item.id == tabId ? { color: '#0A4DCC', fontWeight: 'bold' } : {},
          ]"
          :key="index"
        >
          {{ item.name }}
          <div v-if="item.id == tabId" class="common-line"></div>
        </div>
      </div>

      <div
        v-show="tabId == 1"
        class="common-flex common-flex-wrap customer-box"
      >
        <div v-for="(item, index) in basicList" :key="index">
          <rIpt v-if="item.type == 'input'" :config="item"></rIpt>
          <!-- <rIptText v-if="item.type == 'iptText'" :config="item"></rIptText> -->
          <rIptSelect
            v-if="item.type == 'iptSelect'"
            :config="item"
            :index="index"
            @changeIptSelect="changeIptSelect"
          ></rIptSelect>
          <rSelect v-if="item.type == 'select'" :config="item"></rSelect>
          <rInputDate v-if="item.type == 'date'" :config="item"></rInputDate>
        </div>
      </div>
      <div class="dress-style-box" v-show="tabId == 2">
        <!-- <div> -->
        <div
          class="dress-style common-flex common-rowUnder"
          style="overflow-x: auto; overflow-y: hidden"
        >
          <div
            v-for="(item, index) in style"
            :key="index"
            class="common-flex common-align-center"
            style="white-space: nowrap"
          >
            <div class="style-name">
              {{ index + 1 }}.{{ item.name }}
              <div v-if="styleIndex == index" class="triangle"></div>
            </div>
            <Icon
              v-if="index != style.length - 1"
              style="margin: 0 15px"
              type="ios-arrow-forward"
            />
          </div>
        </div>
        <!-- </div> -->
        <div
          class="style-list common-flex common-justify-center"
          v-if="style[styleIndex] && style[styleIndex].children"
        >
          <div
            @click="changeStyleChild(item)"
            class="style-item"
            v-for="(item, index) in style[styleIndex].children"
            :key="index"
          >
            <img class="style-img" :src="item.imagePath" alt="" />
            <div class="style-details">{{ item.description }}</div>
            <div
              class="style-item-choose"
              v-if="style[styleIndex].chooseStyleId == item.id"
            ></div>
          </div>
        </div>
        <div
          class="dress-selected common-rowUnder"
          :style="{ height: 'calc(100% + ' + '100px)', overflowY: 'auto' }"
        >
          <div class="selected">{{ $t("addCustomer.selected") }}</div>
          <div
            style="margin: 10px 0"
            @click="chooseStyle(index)"
            class="
              common-hover
              common-flex
              common-justify-between
              common-align-center
            "
            v-for="(item, index) in style"
            :key="index"
          >
            <div class="style-title">{{ item.name }}</div>
            <div class="common-flex">
              <div class="style-content" style="width: 60px">
                {{ item.chooseStyleName }}
              </div>

              <Icon style="margin-left: 5px" type="ios-arrow-forward" />
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="tabId == 3"
        class="common-flex common-flex-wrap customer-box"
      >
        <div v-for="(item, index) in bodyList" :key="index">
          <rIptText
            v-if="item.type == 'iptText'"
            :unit="unit"
            :config="item"
          ></rIptText>
        </div>
      </div>
      <div class="dress-tailor-box" v-show="tabId == 4">
        <div class="tailor-box common-flex common-justify-center">
          <div
            @click="selectCloth(item, index)"
            class="tailor-title-item"
            :style="[
              index == selectClothIndex
                ? { color: '#fff', background: '#0A4DCC', border: 'none' }
                : {},
            ]"
            v-for="(item, index) in tailorList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div
          class="common-flex common-flex-wrap customer-box"
          v-if="tailorList && selectClothIndex !== ''"
        >
          <div
            v-for="(item, index) in tailorList[selectClothIndex].partList"
            :key="index"
          >
            <rIptText :unit="unit" :config="item"></rIptText>
          </div>
        </div>
      </div>
      <div class="common-flex common-justify-center options">
        <div class="back options-btn common-hover" @click="close">
          {{ $t("customer.back") }}
        </div>
        <div class="save options-btn common-hover" @click="save">
          {{ $t("customer.save") }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rIpt from "./r-ipt";
import rSelect from "./r-select";
import rIptSelect from "./r-ipt-select";
import rIptText from "./r-ipt-text";
import rDate from "./r-date";
import rInputDate from "./r-input-date";
export default {
  name: "r-add-new-customer",
  data() {
    return {
      // 特体传参
      styleParams: {
        category: 89,
        parentId: 0,
        property: 10052,
      },
      selectClothIndex: "",
      selectClothId: "",
      unit: {
        heightUnitName: "",
      },

      submitParams: {
        custName: "", //客户姓名
        customerSizeList: [], //尺寸列表
        customerSpecialList: [], //特提列表
        cySizeList: [],
        email: "", //邮箱
        genderId: "", //性别
        height: "", //身高
        id: "",
        heightUnit: "", //身高单位
        phone: "", //电话
        remark: "", //备注
        shortName: "", //昵称
        weight: "", //体重
        weightUnit: "", //体重单位
        address: "", //地址
        birthdate: "", //日期
        custInfo: "", //JSON串信息
      },

      // 尺寸传参
      sizeParams: {
        category: 14,
      },
      show: true,
      tabId: 1,
      styleIndex: 0,
      style: [],
      menu: [
        {
          id: 1,
          name: this.$t("addCustomer.basic"),
        },
        {
          id: 2,
          name: this.$t("addCustomer.style"),
        },
        {
          id: 3,
          name: this.$t("addCustomer.body"),
        },
        {
          id: 4,
          name: this.$t("addCustomer.tailor"),
        },
      ],
      copyBasic: [
        {
          label: this.$t("customer.basicList.name"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.nickname"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.gender"),
          must: true,
          type: "select",
          value: "",
          list: [],
        },
        {
          label: this.$t("customer.basicList.height"),
          must: true,
          inputValue: "",
          type: "iptSelect",
          value: "",
          list: [],
        },
        {
          label: this.$t("customer.basicList.weight"),
          inputValue: "",
          must: false,
          type: "iptSelect",
          value: "",
          list: [],
        },

        {
          label: this.$t("customer.basicList.phone"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.email"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.address"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.DOB"),
          must: false,
          type: "date",
          inputValue: "",
        },
      ],
      tailorList: [],
      basicList: [],
      bodyList: [
        // {
        //   label: "Waist",
        //   must: false,
        //   inputValue: "",
        //   type: "iptText",
        //   suffixValue: "inch",
        // },
      ],
    };
  },
  components: {
    rIpt,
    rSelect,
    rIptSelect,
    rIptText,
    rDate,
    rInputDate,
  },
  watch: {
    addNew: {
      handler(newval) {
        this.show = newval;
        if (newval) {
          this.getGenderDictSystem();
          this.getHeightDictSystem();
          this.getWeightDictSystem();
          this.styleDictbasic();
          this.sizeDictbasic();
          this.getClothSize();
          if (this.edit == 0) {
            this.basicList = JSON.parse(JSON.stringify(this.copyBasic));
          } else {
            // this.style = JSON.parse(JSON.stringify(this.custInfo.style));
            this.basicList = JSON.parse(
              JSON.stringify(this.custInfo.basicList)
            );
            // this.bodyList = JSON.parse(JSON.stringify(this.custInfo.bodyList));
          }
        }
      },
      immediate: true,
    },
    edit: {
      handler(newval) {
        console.log("newval", newval);
        if (newval) {
          this.tabId = newval;
        }
      },
      immediate: true,
    },
    customerId: {
      handler(newval) {
        if (newval) {
          this.submitParams.id = newval;
        }
      },
      immediate: true,
    },
    // custInfo: {
    //   handler(newval) {
    //     console.log(newval)
    //     if(newval&&JSON.stringify(newval)!='{}'){
    //         this.style = newval.style
    //         this.basicList = newval.basicList
    //         this.bodyList = newval.bodyList
    //     }
    //     // this.tabId = newval;
    //   },
    //   immediate: true,
    // },
  },
  props: {
    addNew: Boolean,
    custInfo: Object,
    customerId: [Number, String],
    edit: {
      default: 0,
      type: [Number, String],
    },
  },
  mounted() {
    console.log("显示");
  },
  methods: {
    ...mapActions([
      "saveCustomerAction", //保存客户
      "dictbasicAction", //字典
      "getDictSystemAction", //系统
      "getClothSizeAction", //品类
    ]),
    selectCloth(e, index) {
      //  this.selectClothId = e.clothId
      this.selectClothIndex = index;
    },
    // 获得品类
    getClothSize() {
      this.getClothSizeAction().then((res) => {
        if(this.custInfo && this.custInfo.cySizeList){
          res.data.map((item) => {
            this.custInfo.cySizeList.map((citem) => {
              // item.map((sitem) => {
                if (citem.clothId == item.clothId) {
                  citem.partList.map((pitem) => {
                    item.partList.map((spitem) => {
                      if (pitem.partId == spitem.partId) {
                          spitem.inputValue = pitem.partSize;
                      }
                    });
                  });
                }
              // });
            });
          });
        }
        this.tailorList = res.data;
        // this.selectClothId = res.data[0].clothId
        this.selectClothIndex = 0;

      });
    },
    // 修改 iptselect的下拉框选项
    changeIptSelect(e) {
      console.log("e", e);
      if (e == 3) {
        this.basicList[3].list.map((item) => {
          if (item.value == this.basicList[3].value) {
            this.unit.heightUnitName = item.name;
            this.bodyList.map((bitem) => {
              bitem.suffixValue = item.label;
            });
          }
        });
      }
    },
    save() {
      // console.log('tailorList',this.tailorList)
      this.submitParams.cySizeList = [];
      this.submitParams.customerSpecialList = []
      this.tailorList.map((item, index) => {
        this.submitParams.cySizeList.push({
          clothId: item.clothId,
          partList: [],
        });
        item.partList.map((citem) => {
          if (citem.inputValue) {
            this.submitParams.cySizeList[index].partList.push({
              partId: citem.partId,
              partSize: citem.inputValue,
            });
          }
        });
      });
      console.log("this.submitParams", this.submitParams.cySizeList);
      let pass = true;
      for (var i = 0; i < this.basicList.length; i++) {
        if (this.basicList[i].must && this.basicList[i].inputValue == "") {
          pass = false;
          this.$Message.error(
            this.$t("customer.saveTips." + this.basicList[i].label)
          );
          break;
        }
      }
      // 验证通过 进行赋值
      if (pass) {
        // 基本信息赋值
        this.submitParams.custName = this.basicList[0].inputValue;
        this.submitParams.shortName = this.basicList[1].inputValue;
        this.submitParams.genderId = this.basicList[2].value;
        this.submitParams.height = this.basicList[3].inputValue;
        this.submitParams.heightUnit = this.basicList[3].value;
        this.submitParams.weight = this.basicList[4].inputValue;
        this.submitParams.weightUnit = this.basicList[4].value;
        this.submitParams.phone = this.basicList[5].inputValue;
        this.submitParams.email = this.basicList[6].inputValue;
        this.submitParams.address = this.basicList[7].inputValue;
        this.submitParams.birthdate = this.basicList[8].inputValue;
        // 尺寸信息赋值
        // customerSizeList  尺寸信息

        this.submitParams.customerSizeList = [];
        this.bodyList.map((item) => {
          this.submitParams.customerSizeList.push({
            partId: item.id,
            partSize: item.inputValue || "",
          });
        });
        // 特体信息赋值
        this.customerSpecialList = [];
        this.style.map((item) => {
          this.submitParams.customerSpecialList.push({
            specId: item.chooseStyleId,
          });
        });
        let params = {
          style: "",
          basicList: "",
          bodyList: "",
        };
        params.style = this.style;
        params.basicList = this.basicList;
        params.bodyList = this.bodyList;
        // this.submitParams.custInfo = JSON.stringify(params);
        // console.log(this.submitParams)
        // return
        this.saveCustomerAction(this.submitParams).then((res) => {
          if (res.code == 0) {
            this.$emit("updateList");
          }
        });
        // console.log('this.submitParams',this.submitParams)
      }
    },
    // 性别
    getGenderDictSystem() {
      this.getDictSystemAction({ category: 10 }).then((res) => {
        console.log("res", res);
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        if (this.basicList[2].value == "") {
          this.basicList[2].value = res.data[0].id;
        }
        this.basicList[2].list = res.data;
      });
    },

    // 体重
    getWeightDictSystem() {
      this.getDictSystemAction({ category: 29 }).then((res) => {
        // console.log('res',res)
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        if (this.basicList[4].value == "") {
          this.basicList[4].value = res.data[0].id;
        }
        this.basicList[4].list = res.data;
      });
    },
    // 身高
    getHeightDictSystem() {
      this.getDictSystemAction({ category: 30 }).then((res) => {
        // console.log('res',res)
        this.unit.heightUnitName = res.data[0].name;
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        if (this.basicList[3].value == "") {
          this.basicList[3].value = res.data[0].id;
        }
        this.basicList[3].list = res.data;
      });
    },
    styleDictbasic() {
      this.dictbasicAction(this.styleParams).then((res) => {
        console.log("res", res);
        this.style = res.data;

        res.data.map((item) => {
          item.children.map((citem, index) => {
            if (index == 0) {
              item.chooseStyleName = citem.name;
              item.chooseStyleId = citem.id;
            }
          });
        });
        // 单独编辑进入
        console.log("this.custInfo编辑的", this.custInfo);
        if (this.custInfo) {
          this.unit.heightUnitName = this.custInfo.heightUnitName
          res.data.map((item) => {
            this.custInfo.customerSpecialList.map((citem) => {
              // console.log('编辑了',item.id,citem.desId)
              if (citem.desId == item.id) {
                item.chooseStyleName = citem.specName;
                item.chooseStyleId = citem.specId;
              }
            });
          });
        }
      });
    },
    sizeDictbasic() {
      this.dictbasicAction(this.sizeParams).then((res) => {
        console.log("res", res);
        res.data.map((item) => {
          item.label = item.name;
          item.type = "iptText";
          item.suffixValue = "";
          item.inputValue = "";
        });
        if (this.custInfo) {
          console.log(
            "this.custInfo.customerSizeList",
            this.custInfo.customerSizeList
          );
          res.data.map((item) => {
            this.custInfo.customerSizeList.map((citem) => {
              // console.log('编辑了',item.id,citem.desId)
              if (citem.partId == item.id) {
                item.inputValue = citem.partSize;
                // item.chooseStyleId = citem.specId;
              }
            });
          });
        }
        this.bodyList = res.data;
        console.log("this.bodyList", this.bodyList);
        this.bodyList.map((bitem) => {
          bitem.suffixValue = this.basicList[3].list[0].name;
        });
      });
    },
    // 关闭弹框
    close() {
      this.$emit("handlerAdd");
    },
    // 修改某一项风格
    changeStyleChild(e) {
      let msg = JSON.parse(JSON.stringify(this.style[this.styleIndex]));
      msg.chooseStyleName = e.name;
      msg.chooseStyleId = e.id;
      this.style.splice(this.styleIndex, 1, msg);
      // this.style[this.styleIndex].chooseStyleName = e.name;
      // this.style[this.styleIndex].chooseStyleId = e.id;
    },
    // 选择风格
    chooseStyle(e) {
      this.styleIndex = e;
    },
    // 选择不同分类
    changeTab(e) {
      // if (this.edit) {
      // } else {
        this.tabId = e.id;
      // }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
/deep/.ivu-modal-body {
  padding: 0;
}
/deep/.ivu-input-with-suffix {
  padding-right: 0;
}
/deep/.ivu-modal-wrap {
  z-index: 999 !important;
}
/deep/.ivu-modal-mask {
  z-index: 999 !important;
}
.style-name {
  position: relative;
  .triangle {
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    margin-right: auto;
    margin-left: auto;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 4px solid #fff;
  }
}
.dress-style-box {
  position: relative;
  .dress-selected {
    width: 214px;
    background: #f8f8f8;
    position: absolute;
    right: 0;
    top: 24px;
    padding: 15px;
    z-index: 9999;
    .selected {
      opacity: 0.4;
      font-size: 12px;
      font-weight: 600;
      text-align: left;
      color: #081938;
      line-height: 14px;
    }
    .style-title,
    .style-content {
      width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.dress-style {
  // width: 100%;
  min-width: 1440px;
  // height: 24px;
  background: #0a4dcc;
  color: #fff;
  font-size: 14px;
  margin-top: 24px;
}
.style-list {
  width: 1000px;
  margin: 40px auto 60px;
  .style-item {
    width: 135px;
    height: 251px;
    margin: 0 20px;
    background: #f8f8f8;
    border-radius: 4px;
    position: relative;
  }
  .style-img {
    width: 125px;
    height: 167px;
    display: block;
    margin: 5px;
  }
  .style-details {
    font-size: 8px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 11px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    line-clamp: 6;
    -webkit-box-orient: vertical;
    height: 63px;
  }
  .style-item-choose {
    width: 135px;
    height: 251px;
    border: 3px solid #1e64d2;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.customer-box {
  width: 1130px;
  margin: 60px auto 0;
  > div {
    margin-bottom: 40px;
    margin-right: 40px;
  }
  > div:nth-child(3n + 3) {
    margin-right: 0;
  }
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.dress-tailor-box {
  .tailor-box {
    height: 70px;
    background: #f8f8f8;
    padding: 20px 0;
    .tailor-title-item {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #afb5be;
      font-size: 12px;
      margin: 0 10px;
      border: 1px solid #afb5be;
    }
  }
}
.options {
  position: relative;
  // width: 1130px;
  margin: 20px auto;
  padding-bottom: 25px;
  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }
  .save {
    background: #0a4dcc;
  }
}
.new-menu {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  text-align: center;
  color: #525e73;
  line-height: 16px;
  padding-top: 20px;
  > div {
    margin: 0 100px;
    position: relative;
    padding-bottom: 12px;
    // margin-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-add-new-customer.vue